/**
 * Blue Corner
 * Simple top left fixed bubble containing Vitall logo
 * Used on non-authenticated routes and onboarding
 */
import React, { memo } from 'react';

import { CornerImage, LogoImage } from './BlueCorner.style';

const BlueCorner = () => (
  <CornerImage data-testid="blue-corner-image">
    <LogoImage data-testid="blue-corner-logo" />
  </CornerImage>
);

export default memo(BlueCorner);
